import React, { useState } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { getApi } from '../../api/endpoints.js';
import UiAction from '../../components/UiAction.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faEdit } from "@fortawesome/free-solid-svg-icons";
import FiltersPartial from './FiltersPartial.js';

const Index = (props) => {
  const [filtersModel, setFiltersModel] = useState({});
  const defaultHeaderConfig = { disableSort: false };
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      value: (row) => {
        return <>
        <span className='mx-2'>
        {row.is_active ? <FontAwesomeIcon icon={faCircle} className="text-success"/> : <FontAwesomeIcon icon={faCircle} className="text-danger"/>}
        </span>
        {row.id}
        </>
      },      
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
      disableSort: true
    },
    {
        ...defaultHeaderConfig,
        label: 'Parent Service Type | Service Type',
        value: (row) => {
          return  `${row.service_type?.parent_name } | ${row.service_type.name}`
        },
        disableSort: true
      },
    {
      ...defaultHeaderConfig,
      label: 'Monthly Minimum Target',
      attr: 'monthly_min_target',
    },
    {
      ...defaultHeaderConfig,
      label: 'Monthly Target ',
      attr: 'monthly_target',
    },
    {
      ...defaultHeaderConfig,
      label: 'Per Activation Rate ',
      attr: 'per_activation_rate',
		},
		{
      disableSort: true,
      label: 'Action',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_leads_earning_config.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onEditClick = (id) => {
    navigate(`/leads_earning_configs/${id}/edit`)
  }


  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_leads_earning_config.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Earning Config</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate(`/leads_earning_configs/new`);
  }

  return <ListingPageComponent
    key={PAGES.LeadsEarningConfigsPage.name}
    uiPage={uiManager.getUiPage(PAGES.LeadsEarningConfigsPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Leads Earning Configuration'}]}
    listingMutation={getApi('leadsEarningConfig')}
    className="leads-earning-config-listing-page"
    contentHeading="Leads Earning Configurations - Results"
    headers={headers}
    recordsKey="lead_earning_configurations"
    searchBy={['ID', 'Circle']}
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    filtersModel={filtersModel}
    filters={
      <FiltersPartial
        filtersModel={filtersModel}
        setFiltersModel={setFiltersModel}
      />
    }
  />
}

export default Index;
